export default {"src":"/_next/static/media/zurich.63f79d78.svg","height":35,"width":152,"blurWidth":0,"blurHeight":0};